<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Edit contact</h1>

  <app-contact-form [contact]="contact" (submit)="onSubmit($event)"></app-contact-form>
</app-base-modal>
